import { AppId, FCX, ProductLogo } from "@datassential/platform-ui-lib";

const HomeSectionLoader: FCX = () => {
    return (
        <div className="Home__sub-wrapper min-height HomeSection__loader">
            <div className="spinner spinner-blink">
                <ProductLogo appId={AppId.Snap} type="regular"/>
            </div>
        </div>
    );
};

export default HomeSectionLoader;